export const UMO_TYPES = ['IMAGE', 'AUDIO', 'VIDEO', 'DOCUMENT'];
export const UMO_TYPE_PHOTO = 'PHOTO';
export const UMO_TYPE_AUDIO = 'AUDIO';
export const UMO_TYPE_VIDEO = 'VIDEO';
export const UMO_TYPE_DOCUMENT = 'DOCUMENT';
export const DPI_TYPES = [
    { value: '72x72', name: '72 dpi' },
    { value: '96x96', name: '96 dpi' },
    { value: '150x150', name: '150 dpi' },
    { value: '300x300', name: '300 dpi' },
    { value: '600x600', name: '600 dpi' },
    { value: '1200x1200', name: '1200 dpi' },
];
export const IMAGE_TYPES = ['JPEG', 'PNG', 'GIF', 'TIFF'];
export const UMO_MODIFY_TYPE_CROP = 'CROP';
export const UMO_MODIFY_TYPE_COPY = 'COPY';
export const UMO_MODIFY_TYPE_ROTATE = 'ROTATE';
export const UMO_MODIFY_TYPE_RESIZE = 'RESIZE';
export const UMO_MODIFY_TYPE_ZIP_DOWNLOAD = 'ZIP_DOWNLOAD';
export const UMO_MODIFY_TYPE_PDF_DOWNLOAD = 'PDF_DOWNLOAD';



// WEBPACK FOOTER //
// ./src/js/constants/umoModifications.js